module.exports = __webpack_public_path__ + "static/media/bugsmall.c7c45a66.jpg";